export const AMOUNT_FOR_PLACEMENT_TEST = 20000;
export const NAME_FOR_PLACEMENT_TEST = '이바인 입학시험테스트';
